import React from 'react';
import { NavLink, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useData } from '../data/DataProvider';
import { pbEngineer } from '../lib/pb';
import { signOutEngineer } from '../lib/auth';
import SafeIcon from '../common/SafeIcon';
import { Icons } from '../shared/icons';
import './engineer.css';

export default function EngineerShell() {
  const { tenantSlug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = useData();
  const record = pbEngineer.authStore.record;
  
  const base = `/engineer/${tenantSlug}`;
  
  const links = [
    { path: '', label: 'Dashboard', icon: Icons.Home, end: true },
    { path: 'jobs', label: 'Job Sheets', icon: Icons.FileText },
    { path: 'certificates', label: 'Certificates', icon: Icons.FileText },
    { path: 'signatures', label: 'Signatures', icon: Icons.Pen },
    { path: 'files', label: 'File System', icon: Icons.FileText },
    { path: 'mapping', label: 'Mapping', icon: Icons.Map },
    { path: 'messages', label: 'Messages', icon: Icons.MessageCircle },
    { path: 'parts', label: 'Parts DB', icon: Icons.Package },
    { path: 'faults', label: 'Faults DB', icon: Icons.AlertTriangle },
    { path: 'expenses', label: 'Expenses', icon: Icons.Cash },
  ];

  const signOut = () => {
    signOutEngineer();
    navigate(`/engineer/login${tenantSlug ? `/${tenantSlug}` : ''}`, { replace: true });
  };

  return (
    <div className="engineer-frame">
      <header className="engineer-header" style={{ '--engineer-brand': data.tenant.primary_color }}>
        <div className="brand">
          <div className="brand-mark"><SafeIcon icon={Icons.Wrench} /></div>
          <div>
            <strong>{data.tenant.name.split(' ')[0].toLowerCase()}</strong>
            <span>ENGINEER PORTAL</span>
          </div>
        </div>
        <nav className="engineer-nav">
          {links.map((link) => (
            <NavLink key={link.label} end={link.end} to={`${base}/${link.path}`}>
              <SafeIcon icon={link.icon} />
              <span>{link.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="engineer-account">
          <span>{record?.name?.split(' ').map(n => n[0]).join('') || 'EN'}</span>
          <strong>{record?.name || 'Engineer'}</strong>
          <button
            className="icon-button engineer-logout"
            aria-label="Sign out"
            title="Sign out"
            onClick={signOut}
          >
            <SafeIcon icon={Icons.LogOut} />
          </button>
        </div>
      </header>
      <main className="engineer-main"><Outlet /></main>
      <nav className="mobile-tabs">
        {links.map((link) => (
          <NavLink key={link.label} end={link.end} to={`${base}/${link.path}`}>
            <SafeIcon icon={link.icon} /><span>{link.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}